import { buildComponent } from '#components'
import Swiper from 'swiper'
import { Navigation, Scrollbar } from 'swiper/modules'

import './homepage-social.css'

const HomepageSocial = buildComponent({
  name: 'homepage-social',
  onConnected(component) {
    const socialSliderEl = component.querySelector<HTMLElement>('[data-social-slider]')

    if (!socialSliderEl || socialSliderEl.classList.contains('swiper-initialized')) return

    const nextEl = component.querySelector<HTMLElement>('.swiper-button-next')
    const prevEl = component.querySelector<HTMLElement>('.swiper-button-prev')
    const scrollbarEl = component.querySelector<HTMLElement>('.swiper-scrollbar')

    new Swiper(socialSliderEl, {
      modules: [Navigation, Scrollbar],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl,
        prevEl
      },
      scrollbar: {
        el: scrollbarEl,
        hide: false
      },
      breakpoints: {
        750: {
          slidesPerView: 2.5
        },
        990: {
          slidesPerView: 4
        }
      }
    })
  }
})

// Don't forget to declare the element tag name
// this is helpful for TypeScript to recognize the element`
declare global {
  interface HTMLElementTagNameMap {
    'homepage-social': typeof HomepageSocial
  }
}
